export * from './AnnouncementBase';
export * from './AnnouncementDefault';
export * from './AnnouncementSocialMedia';
export * from './AnnouncementContent';
export * from './AnnouncementReachVideo';
export * from './AnnouncementYoutube';
export * from './AnnouncementVimeo';

export function round(num: number, places: number): number {
    const multiplier = Math.pow(10, places);
    return Math.round(num * multiplier) / multiplier;
}

export function autosizeImage(
    maxHeight: number,
    maxWidth: number,
    wrapperElem: HTMLElement | string,
    imgElem: HTMLElement | string
): void {
    if (typeof wrapperElem === 'string') {
        const maybeWrapperElem = document.querySelector<HTMLElement>(wrapperElem);

        if (!maybeWrapperElem) {
            return;
        }

        wrapperElem = maybeWrapperElem;
    }

    if (typeof imgElem === 'string') {
        const maybeImgElem = document.querySelector<HTMLElement>(imgElem);

        if (!maybeImgElem) {
            return;
        }

        imgElem = maybeImgElem;
    }

    const maxImageHeight = maxHeight - 20;
    const maxImageWidth = maxWidth - 60;

    const picWidth = imgElem.clientWidth;
    const picHeight = imgElem.clientHeight;

    const widthRatio = round(maxImageWidth / picWidth, 2);
    const heightRatio = round(maxImageHeight / picHeight, 2);

    const resizeRatio = widthRatio < heightRatio ? widthRatio : heightRatio;

    const newHeight = Math.round(resizeRatio * picHeight);
    const newEidth = Math.round(resizeRatio * picWidth);

    imgElem.style.width = `${newEidth}px`;
    imgElem.style.height = `${newHeight}px`;

    wrapperElem.classList.remove('img_autosize_hidden');
    wrapperElem.classList.add('img_autosize_wrapper');
}
